/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section2_TitleInputs */

const en_terms_section2_title = /** @type {(inputs: Terms_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description of Service`)
};

const ko_terms_section2_title = /** @type {(inputs: Terms_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서비스 설명`)
};

const ja_terms_section2_title = /** @type {(inputs: Terms_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスの説明`)
};

/**
* | output |
* | --- |
* | "Description of Service" |
*
* @param {Terms_Section2_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section2_title = /** @type {((inputs?: Terms_Section2_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section2_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section2_title(inputs)
	if (locale === "ko") return ko_terms_section2_title(inputs)
	return ja_terms_section2_title(inputs)
});